export default __webpack_public_path__ + "static/media/home-icon.6b32ff5e.svg";